@if (!item.hidden && (isGrantedRole && (!item.isCoordenador || (item.isCoordenador && isCoordenador)))) {
  <div class="group-title" [ngClass]="item.classes" role="presentation">
    <span class="hint-text" [translate]="item.translate" id="nav-group-{{item.id}}">{{ item.title }}</span>
  </div>
  <div class="group-items" role="group" [attr.aria-labelledby]="'nav-group-' + item.id">
    @for (item of item.children; track item) {
      @if (item.type==='group') {
        <cdk-nav-vertical-group [item]="item"></cdk-nav-vertical-group>
      }
      @if (item.type==='collapsable') {
        <cdk-nav-vertical-collapsable
        [item]="item"></cdk-nav-vertical-collapsable>
      }
      @if (item.type==='item') {
        <cdk-nav-vertical-item [item]="item"></cdk-nav-vertical-item>
      }
    }
  </div>
}
